import { Action } from '@ngrx/store';
import {
  BatchUpdateSession,
  NesSession,
  NesSessionsInfo,
} from '@deltager/organizers/admin/modules/event-sessions/event-session-calendar/session.model';
import { SessionName } from '@deltager/organizers/admin/modules/event-sessions/event-session-calendar/session.model';
import { PriceSessionSetup } from '@deltager/organizers/admin/modules/event-sessions/components/price-assign-session-popup/price-assign-helper';

export enum SessionsActionTypes {
  LoadEventSessions = '[Sessions] Load event sessions',
  LoadEventSessionsSuccess = '[Sessions] Load event sessions success',
  SaveSession = '[Sessions] Save session',
  SaveSessionSuccess = '[Sessions] Save session success',
  GetSession = '[Sessions] Get session',
  GetSessionSuccess = '[Sessions] Get session success',
  GetSessionsNames = '[Sessions] Get sessions names',
  GetSessionsNamesSuccess = '[Sessions] Get sessions names success',
  EditSession = '[Sessions] Edit session',
  EditSessionSuccess = '[Sessions] Edit session success',
  DeleteSession = '[Sessions] Delete session',
  DeleteSessionSuccess = '[Sessions] Delete session success',
  BatchEditSession = '[Sessions] Batch edit session',
  BatchEditSessionSuccess = '[Sessions] Batch edit session success',
  BatchDeleteSession = '[Sessions] Batch delete session',
  BatchDeleteSessionSuccess = '[Sessions] Batch delete session success',
  ClearFieldInStorage = '[Sessions] Clear field in storage',
  SetPriceSessionSetup = '[Sessions] Set price session setup',
  SetPriceSessionSetupSuccess = '[Sessions] Set price session setup success',
}

interface SessionPayload {
  session?: NesSession;
  eventId?: number;
  from?: string;
  to?: string;
}

export class ClearFieldInStoragesAction implements Action {
  readonly type = SessionsActionTypes.ClearFieldInStorage;

  constructor(public payload: { propertyNames: string[] }) {}
}

export class SetPriceSessionSetupAction implements Action {
  readonly type = SessionsActionTypes.SetPriceSessionSetup;

  constructor(public payload: { priceId: number; eventId: number; ps: PriceSessionSetup }) {}
}

export class SetPriceSessionSetupSuccessAction implements Action {
  readonly type = SessionsActionTypes.SetPriceSessionSetupSuccess;

  constructor() {}
}

export class GetSessionNamesAction implements Action {
  readonly type = SessionsActionTypes.GetSessionsNames;

  constructor(public payload: { eventId: number }) {}
}

export class GetSessionNamesSuccessAction implements Action {
  readonly type = SessionsActionTypes.GetSessionsNamesSuccess;

  constructor(public payload: { sessionsList: SessionName[] }) {}
}

export class DeleteSessionAction implements Action {
  readonly type = SessionsActionTypes.DeleteSession;

  constructor(public payload: SessionPayload) {}
}

export class GetSessionAction implements Action {
  readonly type = SessionsActionTypes.GetSession;

  constructor(public payload: SessionPayload) {}
}

export class GetSessionSuccessAction implements Action {
  readonly type = SessionsActionTypes.GetSessionSuccess;

  constructor(public payload: { session: NesSession }) {}
}

export class LoadEventSessionsAction implements Action {
  readonly type = SessionsActionTypes.LoadEventSessions;

  constructor(public payload: SessionPayload) {}
}

export class LoadEventSessionsSuccessAction implements Action {
  readonly type = SessionsActionTypes.LoadEventSessionsSuccess;

  constructor(public payload: NesSessionsInfo) {}
}

export class SaveSessionsAction implements Action {
  readonly type = SessionsActionTypes.SaveSession;

  constructor(public payload: SessionPayload) {}
}

export class EditSessionAction implements Action {
  readonly type = SessionsActionTypes.EditSession;

  constructor(public payload: SessionPayload) {}
}

export class BatchEditSessionAction implements Action {
  readonly type = SessionsActionTypes.BatchEditSession;

  constructor(
    public payload: {
      session: BatchUpdateSession;
      eventId?: number;
      from?: string;
      to?: string;
    },
  ) {}
}

export class BatchDeleteSessionAction implements Action {
  readonly type = SessionsActionTypes.BatchDeleteSession;

  constructor(
    public payload: {
      sessionNames: string[];
      eventId?: number;
      from?: string;
      to?: string;
    },
  ) {}
}
